function forceMuteVideos() {
  document.querySelectorAll('video').forEach(video => {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    video.addEventListener('volumechange', () => {
      if (!video.muted || video.volume !== 0) {
        video.muted = true;
        video.volume = 0;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', forceMuteVideos);

window.addEventListener('load', forceMuteVideos);

setInterval(forceMuteVideos, 1000);

const observer = new MutationObserver(() => {
  forceMuteVideos();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});